/**
 * This is a simple dropdown component
 * 
 * Options: 
 *      selectedClassName: string (default: is-selected) - The class name of a selected dropdown element
 *      hideClass: bool (default: is-hidden) - The class name that the dropdown content element has to be hidden
 *      valueIsObject: bool (default: false) - If set to true, the return value contains an object, initial value must be json encoded
 *      DEPRECATED: openCallback: (a function to be called when the dropdown opens, use eventDispatcher instead)
 * 
 * Events: 
 *      open: Is triggered when the dropdown opens
 *      close: Is triggered when the dropdown closes
 * 
 * @param {type} $
 * @param {type} Object
 * @param {type} Widget
 * @returns {_L8.Dropdown}
 */
define([
    'jQuery',
    'library/hammerjs/hammer',
    'library/fcse-compatibility/object',
    'library/fcse-widget/widget'],
    function($, Hammer, Object, Widget) {
        
        var Dropdown = function (element, options) {
            Widget.apply(this, arguments);
            
            // Set default options
            var defaultOptions = {
                'selectedClassName': 'is-selected',
                'hideClass': 'is-hidden',
                'openClass': 'is-open',
                'closedClass': 'is-closed',
                'valueIsObject' : false,
                'openCallback': null
            };
            
            //Add default options and custom options
            this.addOptions(defaultOptions, options);
            
            this._registerClickEvent();
            
            //Register events
            this.registerEvent('open');
            this.registerEvent('close');
            
        };

        Dropdown.prototype = $.extend(Object.create(Widget.prototype), {
            
            /**
             * Registers click events
             */
            _registerClickEvent: function () {
                var self = this;

                // Click on button
                $('[data-fcse-role="dropdown--btn"]', this.element).on("click", $.proxy(function (e) {
                    self.toggleDropdown();
                    e.preventDefault();
                }, self));

                var onClickHandler = function(e){
                    // this is to prevent 'ghost click' on touch surfaces
                    if (typeof e.gesture != 'undefined') {
                        e.gesture.srcEvent.preventDefault();
                    }

                    var $this = $(this);

                    var comparableOptionValue = self._valueToString(self._processData($this.attr('data-value')), self.option('valueIsObject'));
                    var comparableValue = self._valueToString(self.getValue(), self.option('valueIsObject'));
                    if (comparableOptionValue !== comparableValue){
                        if (self.option('valueIsObject')){
                            self.setValue(self._processData($this.attr('data-value')));
                        } else {
                            self.setValue($this.attr('data-value'));
                        }
                        if ($('[data-fcse-role="dropdown--label"]', self.element)) {
                            $('[data-fcse-role="dropdown--label"]', self.element).text($this.text());
                        }
                    }
                    self.closeDropdown();
                    e.preventDefault();
                };
                // we check if we have touch-enabled browser
                if ('ontouchstart' in document.documentElement) {
                    // if yes, bind to 'tap' event here
                    $('[data-value]', this.element).each(function(){
                        var hammerifiedElement = new Hammer(this);
                        hammerifiedElement.on('tap', $.proxy(onClickHandler, this));
                    });
                } else {
                    // if no, we bind to the 'click' event
                    // Click on dropdown option
                    $('[data-value]', this.element).on('click', onClickHandler);
                }
            },
            
            _valueToString : function(value, valueIsObject) {
                if (valueIsObject){
                    return JSON.stringify(value);
                } else {
                    return '' + value;
                }
            },
            
            _stopEventPropagation: function(e){
                e.stopPropagation();
            },
            
            /**
             * Opens the dropdown select
             */
            openDropdown: function() {
                $('[data-fcse-role="dropdown--content"]', this.element).removeClass(this.option('hideClass'));
                var self = this;
                $(this.element).trigger('click');
                $('html').on('click', $.proxy(self.closeDropdown, self));
                self.element.on('click', self._stopEventPropagation);
                this.element.removeClass(this.option('closedClass'));
                this.element.addClass(this.option('openClass'));
                if(typeof this.option('openCallback') === 'function') {
                    this.option('openCallback')(this);
                }
                this.dispatchEvent('open');
            },
            
            /**
             * Closes the dropdown select
             */
            closeDropdown: function() {
                $('[data-fcse-role="dropdown--content"]', this.element).addClass(this.option('hideClass'));
                this.element.off('click', this._stopEventPropagation);
                this.element.addClass(this.option('closedClass'));
                this.element.removeClass(this.option('openClass'));
                $('html').off('click', $.proxy(this.closeDropdown, this));
                this.dispatchEvent('close');
            },
            
            /**
             * Toggle open or close the dropdown select
             */
            toggleDropdown: function() {
                if ($('[data-fcse-role="dropdown--content"]', this.element).hasClass(this.option('hideClass'))){
                    this.openDropdown();
                } else {
                    this.closeDropdown();
                }
            },
            
            /**
             * Processes initial value
             * @param {type} data
             * @returns {unresolved}
             */
            _processData: function (data) {
                if (this.option('valueIsObject')){
                    if ($.isPlainObject(data)){
                        return data;
                    } else {
                        return $.parseJSON(data);
                    }
                } else {
                    return data;
                }
            },
            
            /**
             * Renders value to the UI
             */
            setValueToUi: function () {
                var self = this;
                $.each($('[data-value]', this.element), function(index, element){
                    var $this = $(element);
                    var comparableOptionValue = self._valueToString(self._processData($this.attr('data-value')), self.option('valueIsObject'));
                    var comparableValue = self._valueToString(self.getValue(), self.option('valueIsObject'));
                    if (comparableOptionValue === comparableValue){
                        $(element).addClass(self.option('selectedClassName'));
                        if ($('[data-fcse-role="dropdown--label"]', self.element)) {
                            $('[data-fcse-role="dropdown--label"]', self.element).text($this.text());
                        }
                    } else {
                        $(element).removeClass(self.option('selectedClassName'));
                    }
                });
            },
            
            /**
             * Returns the label for the value
             * @returns string
             */
            formatValue : function() {
                if ($('[data-fcse-role="dropdown--label"]', this.element)){
                    return $('[data-fcse-role="dropdown--label"]', this.element).text();
                } else {
                    return '';
                }
            }
        });

        return Dropdown;
    }
);



//////////////////
// WEBPACK FOOTER
// ./~/fcse-dropdown/dropdown.js
// module id = 34
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23